// ** Third Party Components
import Avatar from '@components/avatar'

// ** Logo
import logo from '@src/assets/images/logo/logo.png'

const Loader = () => {
  return (
    <div className='fallback-spinner vh-100'>
      <Avatar
        className='fallback-logo'
        img={logo}
        style={{
          backgroundColor: 'transparent',
          left: 'calc(50% - 63px)'
        }}
        imgHeight="110px"
        imgWidth="110px"
      />
      <div className='loading'>
        <div className='effect-1 effects'></div>
        <div className='effect-2 effects'></div>
        <div className='effect-3 effects'></div>
      </div>
    </div>
  )
}

export default Loader
